<template>
  <div>
    <!-- CRM Mode Banner -->
    <!-- <div class="crm-banner text-center py-2" :class="currentCrmMode === 'hova' ? 'bg-primary' : 'bg-success'" v-if="canSwitchCrm">
      <span class="text-white font-weight-bold">
        {{ currentCrmMode === 'hova' ? 'Hova' : currentCrmMode === '10b' ? '10B' : 'Hova & 10B' }}
      </span>
    </div> -->

    <header class="d-flex justify-content-between py-2">
      <router-link to="/" class="col-auto crm-logo">
        <img src="@/assets/icecreamIn.svg" width="180px" class="img-fluid" alt="">
      </router-link>

      <div class="d-flex">
        <!--<notification :counter="4"/>-->
        <user/>
        <button class="btn btn-sm btn-danger" @click="$store.dispatch('logout')">{{$t('message.logout')}}</button>
        <div class="mx-1"></div>
        <button class="btn btn-sm btn-primary" @click="openNewOrder()">{{$t('message.openNewOrder')}}</button>
        <select class="btn btn-sm btn-danger mr-2" @change="changeCrm($event)" :value="currentCrmMode" v-if="canSwitchCrm">
          <option value="all">הצג את hova/10b</option>
          <option value="hova">הצג את hova</option>
          <option value="10b">הצג את 10b</option>
        </select>
<!--        <button class="btn btn-sm btn-danger mr-2" @click="changeCrm()" v-if="canSwitchCrm">-->
<!--          {{ currentCrmMode === 'hova' ? 'מעבר CRM 10' : 'מעבר CRM hova' }}-->
<!--        </button>-->
      </div>

    </header>
  </div>
</template>


<script>
import notification from '@/components/notification'
import user from '@/components/user'
import axios from "@/axios";


export default {
  name: 'toolbar',
  components: {notification, user},

  data: function () {
    return {
      'newOrderUrl': '',
      'newUrlAddition': ''
    }
  },

  computed: {
    currentCrmMode() {
      return this.$store.getters.currentModeSource
    },
    canSwitchCrm() {
      return this.$store.getters.userAllowCrm === 'all';
    },
  },

  methods: {
    async openNewOrder() {
      let userId = this.$store.getters.userId;
      switch (this.$store.getters.isHostName) {
        case 'localhost':
          this.newOrderUrl = `http://localhost:8080/calc/?aff=${userId}&src=1`;
          break;
        case 'front-stage.hova.co.il':
          this.newOrderUrl = `http://test.hova.co.il/calc/?aff=${userId}&src=1`;
          break;
        default:
          this.newOrderUrl = `https://hova.co.il/calc/?aff=${userId}&src=1`;
      }

      // Proves to hova this click really came from a logged-in agent here (gates the agent-only
      // renewal page) - minted fresh per click, so it has to happen before we navigate, not baked
      // into a static link.
      try {
        const res = await axios.post('issueRenewalLinkToken');
        this.newOrderUrl += `&rtoken=${res.data.token}`;
      } catch (e) {
        alert('לא ניתן היה לאמת את המשתמש, נסה שוב');
        return;
      }

      window.open(this.newOrderUrl, '_blank');
    },
    changeCrm(event) {
      const selectedMode  = event.target.value;
      //const newMode = this.currentCrmMode === 'hova' ? '10b' : 'hova';
      this.$store.dispatch('changeCrmMode', selectedMode);

      // Navigate back to dashboard only if we're not already there
      if (this.$route.path !== '/') {
        this.$router.push('/');
      } else {
        // If we're already on dashboard, refresh the page to update data
        window.location.reload();
      }
    }
  }
}
</script>


